// Generated by CoffeeScript 2.7.0
var GlobalID;

export default GlobalID = class GlobalID {
  constructor(gid1) {
    var _;
    this.gid = gid1;
    // "gid://skylark/YetAnotherWorkflow::Flow/5"
    [_, this.model_name, this.model_id] = this.gid.match(/gid:\/\/skylark\/([\w:]+)\/-?(\d+)/);
  }

  static build(model_name, model_id) {
    return new GlobalID(`gid://skylark/${model_name}/${model_id}`);
  }

  static locate(gid) {
    if (!gid) {
      return;
    }
    if (gid.constructor === this) {
      return gid;
    } else {
      return new GlobalID(gid);
    }
  }

  toPath(plural_name = `${this.model_name}s`) {
    return `/${plural_name.underscore()}/${this.model_id}`;
  }

};
